import {DefinitionsList as DefinitionsListShared} from '@github-ui/custom-properties-core/components/DefinitionsList'
import type {BusinessCustomPropertiesDefinitionsPagePayload} from '@github-ui/custom-properties-types'
import {businessOrgCustomPropertyDetailsPath, customPropertyDetailsPath} from '@github-ui/paths'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {Pagination} from '@primer/react'
import {useState} from 'react'

import {DefinitionsPageHeader} from '../components/PropertiesHeaderPageTabs'
import {usePropertiesListResults} from '../hooks/use-properties-list'
import {usePropertySource} from '../hooks/use-property-source'
import {DefinitionsFilter} from './DefinitionsFilter'

export function BusinessCustomPropertiesPage() {
  const {ownDefinitionsCount, ...payload} = useRoutePayload<BusinessCustomPropertiesDefinitionsPagePayload>()
  const showFilterDialog = useFeatureFlag('repos_list_show_filter_dialog')
  const {sourceName} = usePropertySource()

  const {
    payload: {totalCount, pageCount, definitions, currentQ},
    currentPage,
    fetchResults,
  } = usePropertiesListResults({initialPayload: payload})

  const [filterQuery, setFilterQuery] = useState(currentQ)

  return (
    <>
      <DefinitionsPageHeader permissions="definitions" ownDefinitionsCount={ownDefinitionsCount} />
      <DefinitionsFilter
        className="tmp-mb-3"
        variant={showFilterDialog ? 'full' : 'input'}
        filterValue={filterQuery}
        onChange={setFilterQuery}
        businessSlug={sourceName}
        onSubmit={request => fetchResults({page: 1, filterQuery: request.raw})}
      />

      <DefinitionsListShared
        totalCount={totalCount}
        definitions={definitions}
        renderItem={definition => (
          <DefinitionsListShared.Item
            key={definition.source.slug + definition.propertyName}
            settingsLevel="business"
            definition={definition}
            linkTo={
              definition.source.type === 'business'
                ? customPropertyDetailsPath({
                    pathPrefix: 'enterprises',
                    sourceName,
                    propertyName: definition.propertyName,
                  })
                : businessOrgCustomPropertyDetailsPath({
                    business: sourceName,
                    org: definition.source.slug,
                    propertyName: definition.propertyName,
                  })
            }
          />
        )}
      />

      {pageCount > 1 && (
        <Pagination
          currentPage={currentPage}
          pageCount={pageCount}
          onPageChange={(e, page) => {
            e.preventDefault() // Prevent click event from navigating
            fetchResults({page, filterQuery})
          }}
        />
      )}
    </>
  )
}
